import AddShoppingListModal from './add_shopping_list_modal'

export default AddShoppingListModal